import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.css']
})
export class ThumbnailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
